export default __webpack_public_path__ + "static/Screen Shot 2021-12-01 at 20.05.48-3cad7ba2a69a277939ec3c004042c013.png";